.footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 4px;
}

.btnGroup {
	display: flex;
	align-items: center;
	gap: 4px;
}

.toggleBtn {
	all: unset;
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	border-radius: var(--radius-sm);
	cursor: pointer;
	color: var(--color-gray-6);
	/* 탭 후 이어지는 더블탭이 확대로 처리되지 않도록 */
	touch-action: manipulation;
}

/* 터치 기기: 탭 타깃 44px(Apple HIG 최소).
 * 보이지 않는 히트 영역만 키우면 인접 버튼끼리 겹쳐 서로 탭을 뺏으므로
 * 박스 자체를 44px로 두고 간격을 0으로 만들어 중심 간격을 44px로 맞춘다.
 * 박스가 커진 만큼 아이콘도 키워야 빈 여백만 남지 않는다. */
@media (pointer: coarse) {
	.toggleBtn {
		width: 44px;
		height: 44px;
	}

	.toggleBtn svg {
		width: 20px;
		height: 20px;
	}

	.btnGroup {
		gap: 0;
	}
}

.toggleBtn:hover {
	background: rgba(0, 0, 0, 0.04);
}

.toggleBtnActive {
	color: var(--color-primary);
	background: rgba(34, 139, 230, 0.1);
}

.toggleBtnActive:hover {
	background: rgba(34, 139, 230, 0.15);
}

.popover {
	z-index: 1001;
	background: #fff;
	border: 1px solid var(--color-gray-3);
	border-radius: 6px;
	padding: 8px 12px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
	font-size: 12px;
	line-height: 1.5;
	width: max-content;
	max-width: 260px;
	pointer-events: none;
}

.popoverTitle {
	font-size: 13px;
	font-weight: 600;
}

.popoverDesc {
	font-size: 11px;
	color: var(--color-dimmed);
}

.popoverRow {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 11px;
}

kbd {
	display: inline-block;
	padding: 1px 5px;
	font-family: monospace;
	font-size: 11px;
	line-height: 1.4;
	color: var(--color-dimmed);
	background: #f1f3f5;
	border: 1px solid var(--color-gray-3);
	border-radius: 3px;
}

.statusOn {
	color: var(--color-teal);
	font-weight: 600;
}

.statusOff {
	color: var(--color-dimmed);
	font-weight: 600;
}
